// 데이터 인사이트 기능 출시일 — NEW 배지 노출 기준(명세 §2.1). 배포일에 맞춰 갱신한다.
export const FEATURE_RELEASE_DATE = "2026-08-01";
const NEW_BADGE_MONTHS = 2;

function is_insight_new(){
	const expire = new Date(FEATURE_RELEASE_DATE);
	if( Number.isNaN(expire.getTime()) ) return false;
	expire.setMonth(expire.getMonth() + NEW_BADGE_MONTHS);
	return new Date() < expire;
}

export default [
	{
		component: 'CNavItem',
		name: '주문 관리',
		to: '/order/list',
	},
	{
		component: 'CNavGroup',
		name: '거래 관리',
		to: '/deal',
		items: [
			{
				component: 'CNavItem',
				name: '거래 내역조회',
				to: '/deal/list',
			},
			{
				component: 'CNavItem',
				name: '반품 내역',
				to: '/order/return',
			},
			/* {
				component: 'CNavItem',
				name: '정산 관리',
				to: '/deal/clclt',
			}, */
		],
	},
	{
		component: 'CNavItem',
		name: '상품 관리',
		to: '/product/list',
		icon: 'null',
	},
	{
		component: 'CNavItem',
		name: '재고 관리',
		to: '/stock/list',
		icon: 'null',
	},
	{
		component: 'CNavGroup',
		name: '거래처 관리',
		to: '/store/list',
		items: [
			{
				component: 'CNavItem',
				name: '거래처 관리',
				to: '/store/list',
            },
            {
				component: 'CNavItem',
				name: '정산 관리',
				to: '/store/adjustment',
			},
            /*{	//2025.01.02 제거
				component: 'CNavItem',
				name: '월별 매출 원장',
				to: '/store/month_sales_ledger',
			},*/
		],
	},
	{
		component: 'CNavItem',
		name: '채팅/CS 관리',
		to: '/chat/list',
		icon: 'null',
	},
	{
		component: 'CNavGroup',
		name: '이벤트 관리',
		to: '/event',
		items: [
			{
				component: 'CNavItem',
				name: '이벤트 신청',
				to: '/event/list',
			},
			{
				component: 'CNavItem',
				name: '마켓뱅 단독 이벤트',
				to: '/event/marketbang',
			},
		],
	},
	/*{
		component: 'CNavGroup',
		name: '세금계산서 발행',
		to: '/tax',
		items: [
			{
				component: 'CNavItem',
				name: '세금계산서 등록',
				to: '/tax/create',
			},
			{
				component: 'CNavItem',
				name: '세금계산서 전송',
				to: '/tax/send',
			},
		],
	},*/
	{
		component: 'CNavGroup',
		name: '계정 관리',
		to: '/account',
		items: [
			{
				component: 'CNavItem',
				name: '공급사 채널 관리',
				to: '/account/channel',
			},
			{
				component: 'CNavItem',
				name: '직원 계정 생성 관리',
				to: '/account/manager',
			},
			{
				component: 'CNavItem',
				name: '계정 정보 변경',
				to: '/account/info',
			},
		],
	},
	{
		// 수입사 데이터 인사이트 (명세 §2.1 ① — 메뉴 목록 맨 하단 신규 탭)
		// 셀러 셸(사이드바·헤더) 안에서 열리는 일반 페이지 — 별도 창으로 띄우지 않는다.
		component: 'CNavItem',
		name: '데이터 인사이트',
		to: '/insight',
		// NEW 배지는 기능 출시일 기준 2개월간만 노출하고 이후 자동으로 사라진다.
		// 수입사별 최초 조회일이 아니라 "우리가 배포한 날짜 하나"가 기준(전역).
		...(is_insight_new() ? { badge: { "color": "danger", "text": "NEW" } } : {}),
	},
]
